/**
 * The result of a payment return ("did the checkout go through?") belongs to
 * the visit, not to one homepage. Both homepages read it from here, so whichever
 * one is on screen shows it, even when the student switched homepages while it
 * loaded and the answer arrived mid-sweep, when neither was.
 */
export const PAYMENT_STATUS_EVENT = "sandbox_payment_status";

let paymentStatus = { isOpen: false, type: "success" };
const claimedRefIds = new Set();

/**
 * Whether this homepage should check the payment `refId`: only the first one to
 * see it does. Otherwise a switch mid-check would start a second check, whose
 * answer would reopen the popup after the student closed it.
 * @param {string} refId
 * @returns {boolean}
 */
export const claimPaymentCheck = (refId) => {
  if (claimedRefIds.has(refId)) return false;
  claimedRefIds.add(refId);
  return true;
};

/** @returns {{ isOpen: boolean, type: "success"|"failure" }} */
export const readPaymentStatus = () => paymentStatus;

/** @param {"success"|"failure"} type */
export const showPaymentStatus = (type) => {
  paymentStatus = { isOpen: true, type };
  window.dispatchEvent(new Event(PAYMENT_STATUS_EVENT));
};

export const closePaymentStatus = () => {
  paymentStatus = { ...paymentStatus, isOpen: false };
  window.dispatchEvent(new Event(PAYMENT_STATUS_EVENT));
};
